var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { forwardRef, useEffect, useState } from "react";
import luxonGenerateConfig from "rc-picker/lib/generate/luxon";
import classNames from "classnames";
import RCPicker from "rc-picker";
import { Icon } from "../Icon";
import { getStatusClassNames, getLocale, transPlacement2DropdownAlign, getCurrentViewMode, } from "./utils";
import { Spinner } from "../Spinner";
import DatePickerMobile from "./DatePickerMobile";
import variables from "../../theme/variables.module.scss";
import "react-infinite-calendar/styles.css";
import "./style/date-picker.scss";
const DatePicker = (generateConfig) => forwardRef((props, ref) => {
    var _a, _b;
    const { className, label, locale, localeLang, required, status, customPopupContainer, loading, customLoaderComponent, direction = "ltr", bordered = "full", placement = "topLeft", prefixCls = "tecma-date-picker", dataTestId = "tecma-datePicker", allowClear = false, onReset, onCalendarChange } = props, rest = __rest(props, ["className", "label", "locale", "localeLang", "required", "status", "customPopupContainer", "loading", "customLoaderComponent", "direction", "bordered", "placement", "prefixCls", "dataTestId", "allowClear", "onReset", "onCalendarChange"]);
    const [viewMode, setViewMode] = useState(() => getCurrentViewMode(Number.parseInt(variables.tablet, 10)));
    const mobileDatePickerProps = {
        confirmDateLabel: props.confirmDateLabel,
        resetDateLabel: props.resetDateLabel,
        placeholder: props.placeholder,
        disabledDates: props.disabledDates,
        disabledDays: props.disabledDays,
        mobileTitleLabel: props.mobileTitleLabel,
        mobileSubTitleLabel: props.mobileSubTitleLabel,
        formatDateOptions: props.formatDateOptions,
        localeMobileConfig: props.localeMobileConfig,
        minDate: (_a = props.minDate) === null || _a === void 0 ? void 0 : _a.toJSDate(),
        maxDate: (_b = props.maxDate) === null || _b === void 0 ? void 0 : _b.toJSDate(),
        onReset: props.onReset,
        onClose: props.onClose,
        onConfirm: props.onConfirm,
    };
    const localeConfig = Object.assign(Object.assign({}, getLocale(localeLang)), locale);
    useEffect(() => {
        const updateViewMode = () => {
            setViewMode((curr) => {
                const newViewMode = getCurrentViewMode(Number.parseInt(variables.tablet, 10));
                if (curr !== newViewMode) {
                    return newViewMode;
                }
                return curr;
            });
        };
        window.addEventListener("resize", updateViewMode);
        return () => {
            window.removeEventListener("resize", updateViewMode);
        };
    }, []);
    const getPopupContainer = (node) => {
        return customPopupContainer !== null && customPopupContainer !== void 0 ? customPopupContainer : node.parentElement;
    };
    const panelRender = (originalPanel) => {
        return (_jsxs(_Fragment, { children: [originalPanel, loading ? (_jsx("div", { className: `tecma-date-picker-loader ${customLoaderComponent ? "" : "traditional"}`, children: customLoaderComponent !== null && customLoaderComponent !== void 0 ? customLoaderComponent : _jsx(Spinner, {}) })) : null] }));
    };
    if (viewMode === "mobile") {
        return (_jsx(DatePickerMobile, Object.assign({ value: rest.value, localeLang: localeLang, ref: ref }, mobileDatePickerProps)));
    }
    return (_jsxs("div", { className: "tecma-date-picker-wrapper", "data-testid": dataTestId, children: [label && _jsx("span", { className: "tecma-select-label", children: `${label} ${required ? "*" : ""}` }), _jsx(RCPicker, Object.assign({ ref: ref, placement: placement, popupAlign: transPlacement2DropdownAlign(direction, placement), panelRender: panelRender, suffixIcon: _jsx(Icon, { size: "small", iconName: "calendar" }), allowClear: allowClear ? { clearIcon: _jsx(Icon, { size: "small", iconName: "x-circle" }) } : false, prevIcon: _jsx("span", { className: "tecma-date-picker-prev-icon" }), nextIcon: _jsx("span", { className: "tecma-date-picker-next-icon" }), superPrevIcon: _jsx("span", { className: "tecma-date-picker-super-prev-icon" }), superNextIcon: _jsx("span", { className: "tecma-date-picker-super-next-icon" }), transitionName: "tecma-slide-up", className: classNames({
                    "tecma-date-picker-borderless": bordered === "none",
                    "tecma-date-picker-border-bottom": bordered === "bottom",
                }, getStatusClassNames(prefixCls, status), className), prefixCls: prefixCls, generateConfig: generateConfig, getPopupContainer: getPopupContainer, direction: direction, locale: localeConfig, onCalendarChange: onCalendarChange }, rest))] }));
});
export default DatePicker(luxonGenerateConfig);
